import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import AnimatedSection from '../components/AnimatedSection';

const BlogPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main className="pt-24">
        {/* Hero Section */}
        <section className="py-20 bg-gradient-to-b from-white to-gray-50">
          <div className="container mx-auto px-4">
            <AnimatedSection animation="fade-up">
              <div className="text-center max-w-4xl mx-auto">
                <h1 className="text-4xl lg:text-5xl font-bold mb-6" style={{ color: '#214140' }}>
                  Cordflex® Blog
                </h1>
                <p className="text-xl text-gray-600 leading-relaxed">
                  Stay updated with the latest insights, research, and best practices in ICU line management 
                  and patient safety from our team of healthcare professionals.
                </p>
              </div>
            </AnimatedSection>
          </div>
        </section>

      {/* Newsletter Signup */}
        <section className="py-20 bg-white">
          <div className="container mx-auto px-4">
            <AnimatedSection animation="fade-up">
              <div className="text-center max-w-3xl mx-auto">
                <h2 className="text-3xl lg:text-4xl font-bold mb-6" style={{ color: '#214140' }}>
                  Under construction
                </h2>
                <p className="text-xl text-gray-600 mb-8 leading-relaxed">
                  The blog is currently under Construction and is coming soon.
                </p>
              </div>
            </AnimatedSection>
          </div>
        </section>


        {/* Newsletter Signup 
        <section className="py-20 bg-white">
          <div className="container mx-auto px-4">
            <AnimatedSection animation="fade-up">
              <div className="text-center max-w-3xl mx-auto">
                <h2 className="text-3xl lg:text-4xl font-bold mb-6" style={{ color: '#214140' }}>
                  Stay Updated
                </h2>
                <p className="text-xl text-gray-600 mb-8 leading-relaxed">
                  Subscribe to our newsletter to receive the latest articles, research updates, and industry insights directly in your inbox.
                </p>
                <div className="flex flex-col sm:flex-row gap-4 justify-center max-w-md mx-auto">
                  <input
                    type="email"
                    placeholder="Enter your email"
                    className="flex-1 px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-teal-500"
                  />
                  <button
                    className="px-6 py-3 font-semibold rounded-lg hover:opacity-90 transition-opacity duration-200"
                    style={{ backgroundColor: '#214140', color: 'white' }}
                  >
                    Subscribe
                  </button>
                </div>
              </div>
            </AnimatedSection>
          </div>
        </section>*/}
        
      </main>
      <Footer />
    </div>
  );
};

export default BlogPage;